<template>
  <div class="tab-content text-that-needs-wrapping">
    <div class="page-info-shadow" v-show="flagVisible.info" @click.self="flagVisible.info = ''">
      <div class="info-container">
        <div class="info-title">
          <span>Your Player’s Audio is Organized by Song</span>
        </div>
        <div class="info-line">
          <span>Audio <b>Sources</b> are organized under <b>Songs</b>. Even if your example recording has just one <b>Source</b> you’ll start by creating a <b>Song</b> to hold it. This makes it easy to navigate audio content in your ATK Players. </span>
        </div>
        <div class="info-line">
          <span>Songs may be cross-comparable across many products or simply demonstrate a single product.</span>
        </div>
        <div class="info-line">
          <span>A Song could be made of a collection of individual Sources like vocals, drums, and guitars that make up a whole piece of music. Or a Song could also be a collection of sources that belong together – voiceovers and spoken word together in a Song called “Various Voiceovers,” for example. See our </span>
          <span class="info-link-span" @click="$router.push('/client/guide')">Guide</span>
          <span> for help.</span>
        </div>
      </div>
    </div>
    <el-form ref="form" label-position="top" size="small">
      <div class="sources-landing" v-show="flagVisible.landingPage">
        <div class="landing-desc">
          <h1>Your Player’s Audio is Organized by Song</h1>
          <p>Audio <b>Sources</b> are organized under <b>Songs</b>. Even if your example recording has just one <b>Source</b> you’ll start by creating a <b>Song</b> to hold it. This makes it easy to navigate audio content in your ATK Players. </p>
          <p>Songs may be cross-comparable across many products or simply demonstrate a single product.</p>
          <p>A Song could be made of a collection of individual Sources like vocals, drums, and guitars that make up a whole piece of music. Or a Song could also be a collection of sources that belong together – voiceovers and spoken word together in a Song called “Various Voiceovers,” for example. See our Guide for help.</p>
        </div>
        <div class="landing-brief">
          <div class="brief-item">
            <span>Do you want to create a <b>New Song</b> for comparing a single or multiple products?</span>
            <div class="brief-arrow"></div>
          </div>
          <div class="brief-item">
            <span>Do you want to <b>add this product</b> to a Cross-Comparable song you already created?</span>
            <div class="brief-arrow"></div>
          </div>
          <div class="brief-or">
            <span>- or - </span>
          </div>
        </div>
      </div>
      <div class="sources-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click.self="flagVisible.modalSongSelect = true">
          <span @click.self="flagVisible.modalSongSelect = true">CREATE NEW SONG</span>
          <el-icon @click="flagVisible.info = 'new'" v-show="!flagVisible.landingPage" :size="20"><question-filled /></el-icon>
          <!-- <div class="btn-info" v-show="flagVisible.info === 'new'">
            <div class="info-desc">
              <span>Do you want to create a New Song for comparing a single or multiple products?</span>
            </div>
            <div class="info-arrow"></div>
          </div> -->
        </el-button>
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click.self="flagVisible.modalSongCross = true">
          <span @click.self="flagVisible.modalSongCross = true">ADD THIS PRODUCT TO <br/>EXISTING CROSS-COMPARABLE SONG</span>
          <el-icon @click="flagVisible.info = 'add'" v-show="!flagVisible.landingPage" :size="20"><question-filled /></el-icon>
        </el-button>
      </div>
      <div class="sources-container" v-loading="flagLoading.getSongs || flagLoading.save">
        <div class="sources-item" v-for="(song) in allSongs" :key="song._id">
          <div :class="['source-header', song.is_atk === 1 ? 'atk-song' : 'my-song']">
            <div class="header-info">
              <div class="info-left" @click="toggleSongSelect(song._id)">
                <div class="info-icon">
                  <el-icon v-show="!songSelect.includes(song._id)"><arrow-down-bold /></el-icon>
                  <el-icon v-show="songSelect.includes(song._id)"><arrow-up-bold /></el-icon>
                </div>
                <div class="info-title">
                  <span class="title-song">{{ song.name }}</span>
                  <span class="title-writer">{{ song.song_writer }}</span>
                </div>
              </div>
              <div class="info-action">
                <el-icon v-show="song.is_atk !== 1" class="info-icon" :size="20" @click="editSong(song)"><edit /></el-icon>
              </div>
            </div>
            <div class="header-titles">
              <div class="title-item item-source">
                <span>Source</span>
              </div>
              <div class="title-item item-file">
                <span>Original name</span>
              </div>
              <div class="title-item item-file">
                <span>Auto transcode</span>
              </div>
              <div class="title-item item-uploaded">
                <span>Uploaded At</span>
              </div>
              <div class="title-item item-action">
                <span>Action</span>
              </div>
            </div>
          </div>
          <div class="source-content" v-show="songSelect.includes(song._id)">
            <div class="instrument-action" v-show="song.is_atk !== 1">
              <el-button type="text" icon="el-icon-plus" @click="newInstrument(song._id)">
                New Source in this Song
              </el-button>
            </div>
            <div class="instrument-list">
              <div class="instrument-item" v-for="(instrument) in instruments[song._id]"  :key="instrument._id">
                <div class="item-text text-source">
                  <el-icon v-show="song.is_atk !== 1" class="info-icon" :size="20" @click="editInstrument(instrument)"><edit /></el-icon>
                  <span>{{ instrument.name }}</span>
                </div>
                <div class="item-text text-file">
                  {{ instrument.audio.name }}
                </div>
                <div class="item-text text-file">
                  <a
                    :href="generateUrl(instrument.audio.url)" target="_blank"
                    v-show="instrument.audio.url && instrument.audio.url.indexOf('processed') >= 0"
                  >
                    320kbps mp3
                  </a>
                </div>
                <div class="item-text text-uploaded">
                  <span>{{ generateTime(instrument.audio.updated_at) }}</span>
                </div>
                <div class="item-text text-action">
                  <el-upload
                    v-show="!instrumentUpload.includes(instrument._id)"
                    action="" :http-request="uploadAudio" :show-file-list="false"
                    :data_old="{ model: 'products', id: product._id, type: 'audio', instrument: instrument }"
                    :data="{ model: 'products', type: 'audios', product_id: product._id, instrument_id: instrument._id, song_id: instrument.song_id }"
                  >
                    <el-button class="el-btn-blue" size="mini">Upload</el-button>
                  </el-upload>
                  <span v-show="instrumentUpload.includes(instrument._id)">{{ `Uploading... ${loadingPercent ? `(${loadingPercent}%)` : ''}` }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <ModalSongSelect
      :flagVisible="flagVisible.modalSongSelect" @closeModal="flagVisible.modalSongSelect = false"
      @openSongModal="openSongModal"
    />
    <ModalSongNew
      :flagVisible="flagVisible.modalSongNew" @closeModal="flagVisible.modalSongNew = false"
      :role="role" :brandId="brandId" :actionItem="actionItems.song" @afterAddSong="afterAddSong"
    />
    <ModalSongEdit
      :flagVisible="flagVisible.modalSongEdit" @closeModal="flagVisible.modalSongEdit = false"
      :role="role" :brandId="brandId" :actionItem="actionItems.song" @reloadSongs="reloadSongs"
    />
    <ModalSongCross
      :flagVisible="flagVisible.modalSongCross" @closeModal="flagVisible.modalSongCross = false"
      :role="role" :brandId="brandId" @afterAddSong="afterAddSong" :productName="product.general.name"
    />
    <ModalInstrument
      :flagVisible="flagVisible.modalInstrument" @closeModal="flagVisible.modalInstrument = false"
      :role="role" :actionItem="actionItems.instrument" @reloadInstruments="reloadInstruments"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import { ArrowUpBold, ArrowDownBold, Edit, QuestionFilled } from '@element-plus/icons'
import ModalSongSelect from '@/components/modals/songs/Select.vue'
import ModalSongNew from '@/components/modals/songs/New.vue'
import ModalSongEdit from '@/components/modals/songs/Edit.vue'
import ModalSongCross from '@/components/modals/songs/Cross.vue'
import ModalInstrument from '@/components/modals/Instrument.vue'
import _ from 'lodash'
export default {
  name: 'TabAudio',
  props: {
    tab: String,
    tabUpdate: Boolean,
    role: String,
    actionItem: Object
  },
  emits: ['changeSaveTab'],
  components: {
    ArrowUpBold,
    ArrowDownBold,
    Edit,
    QuestionFilled,
    ModalSongSelect,
    ModalSongNew,
    ModalSongEdit,
    ModalSongCross,
    ModalInstrument
  },
  data () {
    const flagLoading = reactive({
      getSongs: false,
      save: false
    })
    const flagVisible = reactive({
      modalInstrument: false,
      modalSongSelect: false,
      modalSongNew: false,
      modalSongEdit: false,
      modalSongCross: false,
      landingPage: false,
      info: ''
    })
    const actionItems = reactive({
      song: {},
      instrument: {}
    })
    return {
      product: { general: {} },
      brandId: '',
      atkSongIds: [],
      songIds: [],
      atkSongs: [],
      songs: [],
      allSongs: [],
      songsPublished: {},
      songSelect: [],
      audio: [],
      instruments: {},
      instrumentUpload: [],
      loadingPercent: '',
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) {
            this.product = { ...val }
            this.brandId = this.product.general.brand_id
          }
          if (val.audio) this.audio = [...val.audio]
          if (val.atk_songs) {
            this.atkSongIds = [...val.atk_songs]
            if (this.role === 'admin') this.getSongs('atk', this.atkSongIds)
          }
          if (val.songs) {
            this.songIds = [...val.songs]
            if (this.songIds.length > 0) this.getSongs('my', this.songIds)
          }
          if (this.role !== 'admin' && this.songIds.length <= 0) this.flagVisible.landingPage = true
        }
      },
      deep: true
    },
    tabUpdate: {
      handler: function (val, oldVal) {
        if (val !== oldVal && val && this.tab === 'Audio') {
          this.updateProduct()
          this.$emit('changeSaveTab', '')
        }
      },
      deep: true
    }
  },
  methods: {
    updateProductAudio: function (audio) {
      this.$emit('changeSaveTab', '')
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'audio', content: audio }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Upload success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateProductAudio', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    generateTime: function (time) {
      if (!time) return ''
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    getSongs: function (type, ids) {
      this.flagLoading.getSongs = true
      let url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/songs?ids=${ids.join()}`
      if (type === 'atk') url += '&is_atk=true'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          if (type === 'atk') {
            that.atkSongs = res.data.list
          } else {
            that.songs = res.data.list
            if (that.role !== 'admin') that.flagVisible.landingPage = that.songs.length <= 0
          }
          res.data.list.map(song => {
            that.getInstruments(song._id)
            that.songsPublished[song._id] = song.is_published === 1
          })
          that.generalAllSongs()
        } else {
          console.error('getSongs', res.msg)
        }
        that.flagLoading.getSongs = false
      }).catch(function (err) {
        console.error('getSongs', err)
        that.flagLoading.getSongs = false
      })
    },
    generalAllSongs: function () {
      let allSongs = []
      allSongs = allSongs.concat(this.songs)
      allSongs = allSongs.concat(this.atkSongs)
      this.allSongs = allSongs
    },
    getInstruments: function (songId) {
      this.flagLoading.getSongs = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instruments?song_id=${songId}&page_num=1&page_size=1000&is_deleted=false`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          const instruments = res.data.list
          instruments.map((item, index) => {
            const audioIndex = _.findIndex(that.audio, { instrument_id: item._id })
            if (audioIndex > -1) {
              instruments[index].audio = that.audio[audioIndex]
            } else {
              instruments[index].audio = {}
            }
          })
          that.instruments[songId] = instruments
        } else {
          console.error('getInstruments', res.msg)
        }
        that.flagLoading.getSongs = false
      }).catch(function (err) {
        console.error('getInstruments', err)
        that.flagLoading.getSongs = false
      })
    },
    toggleSongSelect: function (val) {
      if (this.songSelect.includes(val)) {
        this.songSelect = _.difference(this.songSelect, [val])
      } else {
        this.songSelect.push(val)
      }
    },
    editSong: function (song) {
      const actionSong = this.actionItems.song
      if (actionSong._id !== song._id) {
        this.actionItems.song = { ...song }
      }
      this.flagVisible.modalSongEdit = true
    },
    editInstrument: function (instrument) {
      const actionInstrument = this.actionItems.instrument
      if (actionInstrument._id !== instrument._id) {
        this.actionItems.instrument = { ...instrument }
      }
      this.flagVisible.modalInstrument = true
    },
    afterAddSong: function (song) {
      if (this.songIds.includes(song._id)) return
      this.flagLoading.save = true
      this.songIds.push(song._id)
      this.songSelect.push(song._id)
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products/${this.product._id}`
      const that = this
      const body = { type: 'songs', content: this.songIds }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.getSongs('my', that.songIds)
        } else {
          console.error('afterAddSong', res.msg)
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('afterAddSong', err)
        that.flagLoading.save = false
      })
    },
    reloadSongs: function () {
      this.getSongs('my', this.songIds)
    },
    uploadAudio: async function (params) {
      const { file, data } = params
      this.instrumentUpload.push(data.instrument_id)
      const extention = file.name.split('.').pop()
      let url = `/api/v1/atk_player/aws/presigned_url?mine_type=${extention}`
      for (const key in data) {
        url += `&${key}=${data[key]}`
      }
      const that = this
      this.loadingPercent = ''
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          const presignedUrl = res.data.presigned_url
          const objUrl = new URL(presignedUrl)
          const audioUrl = `${objUrl.origin}${objUrl.pathname}`
          const xhr = new XMLHttpRequest()
          xhr.open('PUT', presignedUrl, true)
          xhr.setRequestHeader('Content-Type', file.type)
          xhr.setRequestHeader('x-amz-acl', 'public-read')
          xhr.onload = () => {
            if (xhr.status === 200) {
              const audioIndex = _.findIndex(that.audio, { instrument_id: data.instrument_id })
              let updateAudio = {}
              if (audioIndex > -1) {
                updateAudio = { ...that.audio[audioIndex], url: audioUrl, name: file.name }
                that.audio[audioIndex] = updateAudio
              } else {
                updateAudio = {
                  song_id: data.song_id,
                  instrument_id: data.instrument_id,
                  url: audioUrl,
                  name: file.name
                }
                that.audio.push(updateAudio)
              }
              const instrumentIndex = _.findIndex(that.instruments[data.song_id], { _id: data.instrument_id })
              if (instrumentIndex > -1) {
                that.instruments[data.song_id][instrumentIndex].audio = updateAudio
              }
              that.updateProductAudio(updateAudio)
            }
            that.instrumentUpload = _.without(that.instrumentUpload, data.instrument_id)
          }
          xhr.onerror = () => {
            console.error('upload to s3 | error')
            that.$message({ type: 'error', message: 'Upload error' })
            that.instrumentUpload = _.without(that.instrumentUpload, data.instrument_id)
          }
          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              const percent = Math.round((event.loaded / event.total) * 100)
              that.loadingPercent = percent
              // console.log('upload to s3 | percent', percent)
            }
          }
          xhr.send(file)
        } else {
          console.error('uploadAudio | presigned_url', res.msg)
          that.$message({ type: 'error', message: res.msg })
          that.instrumentUpload = _.without(that.instrumentUpload, data.instrument_id)
        }
      }).catch(function (err) {
        console.error('uploadAudio | presigned_url', err)
        that.$message({ type: 'error', message: err.msg })
        that.instrumentUpload = _.without(that.instrumentUpload, data.instrument_id)
      })
    },
    // uploadAudioOld: async function (params) {
    //   const { file, data } = params
    //   const instrument = { ...data.instrument }
    //   this.instrumentUpload.push(instrument._id)
    //   const that = this
    //   const formData = new FormData()
    //   formData.append('file', file)
    //   const dataPass = _.omit(data, ['instrument'])
    //   for (const key in dataPass) {
    //     formData.append(key, dataPass[key])
    //   }
    //   this.$service.request({
    //     url: '/api/v1/atk_player/upload/files',
    //     method: 'POST',
    //     data: formData,
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   }).then((res) => {
    //     if (res.code === 200) {
    //       const audioIndex = _.findIndex(that.audio, { instrument_id: instrument._id })
    //       let updateAudio = {}
    //       if (audioIndex > -1) {
    //         updateAudio = { ...that.audio[audioIndex], url: res.record.audio.url, name: file.name }
    //         that.audio[audioIndex] = updateAudio
    //       } else {
    //         updateAudio = {
    //           song_id: instrument.song_id,
    //           instrument_id: instrument._id,
    //           url: res.record.audio.url,
    //           name: file.name
    //         }
    //         that.audio.push(updateAudio)
    //       }
    //       const instrumentIndex = _.findIndex(that.instruments[instrument.song_id], { _id: instrument._id })
    //       if (instrumentIndex > -1) {
    //         that.instruments[instrument.song_id][instrumentIndex].audio = updateAudio
    //       }
    //       that.updateProduct()
    //     } else {
    //       that.$message({ type: 'error', message: res.msg })
    //     }
    //     that.instrumentUpload = _.without(that.instrumentUpload, instrument._id)
    //   }).catch((err) => {
    //     console.error('uploadAudio', err)
    //     that.instrumentUpload = _.without(that.instrumentUpload, instrument._id)
    //   }).then(() => {
    //   })
    // },
    openSongModal: function (type) {
      this.flagVisible.modalSongSelect = false
      this.actionItems.song = { _id: '', name: '', is_published: 0, song_type: type }
      this.flagVisible.modalSongNew = true
    },
    newInstrument: function (songId) {
      const actionInstrument = this.actionItems.instrument
      if (actionInstrument._id) {
        this.actionItems.instrument = { _id: '', song_id: songId, name: '', is_published: 0 }
      } else {
        this.actionItems.instrument = { ...this.actionItems.instrument, song_id: songId }
      }
      this.flagVisible.modalInstrument = true
    },
    reloadInstruments: function (songId) {
      this.getInstruments(songId)
    },
    triggerTabUpdate: function () {
      this.$emit('changeSaveTab', 'Audio')
    },
    generateUrl: function (url) {
      let audioUrl = url
      if (url && url.indexOf('.mp3?t=') > 0 && url.indexOf('processed') > 0) {
        const audioUrlArray = url.split('.mp3?t=')
        audioUrl = `${audioUrlArray[0]}.mp3%3Ft%3D${audioUrlArray[1]}`
      }
      return audioUrl
    }
  }
}
</script>
<style lang="scss">
.dialog-modal-song {
  .el-icon-close {
    font-size: 26px;
  }
  .el-dialog__footer {
    text-align: left;
  }
}
</style>
<style lang="scss" scoped>
.ca-checkbox {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  &.active {
    background: #A5C2CB;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #8BACB4;
  }
  &.inactive {
    background: #F2F2F2;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #E0E0E0;
  }
}
.sources-landing {
  margin-bottom: 10px;
  .landing-desc {
    width: 80%;
    h1 {
      font-size: 22px;
      margin-top: 0;
    }
    p {
      font-size: 16px;
      margin-top: 30px;
    }
  }
  .landing-brief {
    position: relative;
    margin-top: 30px;
    display: flex;
    padding-bottom: 48px;
    .brief-item {
      position: relative;
      width: 320px;
      height: 48px;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      background-color: #F2F2F2;
      &:first-child {
        margin-right: 80px;
      }
      .brief-arrow {
        position: absolute;
        bottom: -48px;
        left: 136px;
        width: 0;
        height: 0;
        border: 24px solid #F2F2F2;
        border-color: #F2F2F2 transparent transparent transparent;
      }
    }
    .brief-or {
      position: absolute;
      top: 60px;
      left: 345px;
    }
  }
}
.sources-actions {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-button {
    width: 320px;
    height: 48px;
    padding: 0 10px;
    line-height: 16px;
    margin: 0 80px 0 0;
    position: relative;
    .el-icon {
      position: absolute;
      right: -25px;
      top: 0;
      color: #777A82;
    }
    // .btn-info {
    //   position: absolute;
    //   left: 0;
    //   top: -50px;
    //   z-index: 4;
    //   .info-desc {
    //     background-color: #F2F2F2;
    //     width: 300px;
    //     height: 48px;
    //     text-align: center;
    //     padding: 0 30px;
    //   }
    //   .info-arrow {
    //     width: 0;
    //     height: 0;
    //     border: 24px solid #F2F2F2;
    //     border-color: #F2F2F2 transparent transparent transparent;
    //   }
    // }
  }
}
.sources-container {
  width: 80%;
  .sources-item {
    margin-bottom: 32px;
    .source-header {
      background-color: #DBE7EA;
      border-radius: 8px;
      padding: 12px 16px;
      font-size: 16px;
      &.my-song {
        background-color: #F2F2F2;
      }
      .header-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .info-left {
          width: 85%;
          display: flex;
          align-items: center;
          cursor: pointer;
          .info-icon {
            margin-right: 12px;
          }
          .info-title {
            .title-song {
              font-size: 18px;
              font-weight: bold;
              margin-right: 12px;
            }
            .title-writer {
              font-size: 14px;
              font-weight: 300;
            }
          }
        }
        .info-action {
          width: 10%;
          display: flex;
          flex-direction: row-reverse;
          .info-icon {
            cursor: pointer;
          }
        }
      }
      .header-titles {
        display: flex;
        .title-item {
          font-weight: bold;
          display: flex;
          align-items: center;
          span {
            margin-right: 5px;
          }
          .text-icon {
            cursor: pointer;
          }
          &.item-source {
            width: 20%;
            padding-left: 26px;
          }
          &.item-file { width: 25%; }
          &.item-uploaded { width: 15%; }
          &.item-action {
            width: 15%;
            display: flex;
            flex-direction: row-reverse;
          }
        }
      }
    }
    .source-content {
      .instrument-action {
        padding: 20px 0 0 12px;
      }
      .instrument-list {
        padding: 0 16px;
        .instrument-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: solid 1px #F2F2F2;
          .item-text {
            &.text-source {
              width: 20%;
              display: flex;
              align-items: center;
              .info-icon {
                margin-right: 12px;
                cursor: pointer;
              }
            }
            &.text-file { width: 25%; }
            &.text-uploaded { width: 15%; }
            &.text-action {
              width: 15%;
              display: flex;
              flex-direction: row-reverse;
            }
          }
        }
      }
    }
  }
}
.page-info-shadow {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(219, 231, 234, 0.8);
  .info-container {
    width: 800px;
    margin: 300px auto 0;
    background-color: white;
    padding: 30px;
    .info-title {
      font-size: 20px;
      font-weight: 700;
    }
    .info-line {
      font-size: 15px;
      margin-top: 20px;
      .info-link-span {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
</style>
